import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-year-picker',
    templateUrl: './year-picker.html',
    styleUrls: ['./year-picker.scss']
})
export class YearPickerComponent implements OnInit {
    years: number[] = [];
    selectedYear: number;

    @Output() yearSelected: EventEmitter<number> = new EventEmitter<number>();

    ngOnInit(): void {
        const currentYear = new Date().getFullYear();
        const startYear = currentYear - 8; // Adjust as per your requirement
         // Adjust as per your requirement
        for (let year = startYear; year <= currentYear; year++) {
            this.years.push(year);
        }

        this.selectedYear = currentYear; // Set the default selected year to the current year
        this.emitYearSelection();
    }

    onYearChange(): void {
        this.emitYearSelection();
    }

    private emitYearSelection(): void {
        this.yearSelected.emit(this.selectedYear);
    }
}
